// Единые тексты ошибок для UI. Держим в одном месте, чтобы формулировки были
// согласованы и правились централизованно.

// Тип 1 — общий фолбэк, когда причины с сервера нет (500/неизвестная ошибка).
export const ERR_GENERIC = "Не удалось выполнить операцию. Попробуйте ещё раз";

// Тип 2 — нет связи с сервером (сетевой сбой / сервер не поднялся).
export const ERR_NETWORK =
    "Нет связи с сервером. Проверьте, что приложение запущено, и повторите";
